import React from 'react';
type ButtonVariant = 'primary' | 'outline' | 'subtle' | 'ghost' | 'navy' | 'danger';
type ButtonSize = 'sm' | 'md' | 'lg' | 'icon';
const base = 'inline-flex items-center justify-center gap-1.5 rounded-xl font-semibold whitespace-nowrap transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-coral focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
const variants: Record<ButtonVariant, string> = {
  primary: 'bg-coral text-white hover:bg-coral-600',
  outline: 'bg-white border border-coral text-coral hover:bg-coral/5',
  subtle: 'bg-muted text-foreground hover:bg-muted/70',
  ghost: 'text-foreground hover:bg-muted',
  navy: 'bg-navy text-white hover:bg-navy-light',
  danger: 'bg-destructive text-white hover:opacity-90'
};
const sizes: Record<ButtonSize, string> = {
  sm: 'h-9 px-3 text-xs',
  md: 'h-10 px-4 text-sm',
  lg: 'h-11 px-5 text-sm',
  icon: 'h-10 w-10 p-0'
};
export interface ButtonStyleOptions {
  variant?: ButtonVariant;
  size?: ButtonSize;
  fullWidth?: boolean;
  className?: string;
}
/**
 * Returns the shared button class string. Use this to style non-<button>
 * elements (e.g. react-router <Link>) so they match the design system exactly.
 */
export function buttonClasses({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = ''
}: ButtonStyleOptions = {}): string {
  return [base, variants[variant], sizes[size], fullWidth ? 'w-full' : '', className].filter(Boolean).join(' ');
}
export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  fullWidth?: boolean;
}
export function Button({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = '',
  type = 'button',
  children,
  ...props
}: ButtonProps) {
  return <button type={type} className={buttonClasses({
    variant,
    size,
    fullWidth,
    className
  })} {...props} data-id="element-1151">
      {children}
    </button>;
}